//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vModal from '@/core/vModal'
// import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'StockModal',
  extends: vModal,
  data () {
    return {
      columns: [ // 欄位宣告
        { name: 'STK_NAME', label: '營業點', field: 'STK_NAME' },
        { name: 'N_STOCK', label: '現有庫存', field: 'N_STOCK' }
      ],
      items: []
    }
  },
  computed: {
    PC_NAME () {
      return this.items.length > 0 ? this.items[0].PC_NAME : ''
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    dataReady () {
      this.items = this.modalData
    }
  }
}
